import { Component, input, signal } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";

@Component({
  selector: "app-left-ui-template",
  imports: [],
  templateUrl: "./left-ui-template.component.html",
  styleUrl: "./left-ui-template.component.css",
})
export class LeftUiTemplateComponent {
  insizonUrl = environment.insizonFrontendBaseUrl;
  cssClass = input<string | null>(null);
  welcomeText = input<string>("Welcome back");
  welcomeSubtitle = input<string>(
    `We create spaces where gossip turns into genuine conversations, helping people bond over stories,
    laughter, and shared moments that bring them closer.`
  );
  year = signal(new Date().getFullYear());

  constructor(private router: Router) {}

  goHome() {
    this.router.navigate([""]);
  }
}
